<template>
<div v-if="currentVisible">
  <el-button icon="edit" size="drawer" @click="openPopup" class="mr-t8"><i class="fas fa-bars"></i></el-button>
  <w-sliding-popup ref="slidingPopup" title="설정" width="350px">
    <div slot="content">
      <slot name="popupContent" />
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
export default {
  name: 'WHamburgerButton',
  computed: {
    currentVisible() {
      return this.$store.getters.isObj;
    },
  },
  methods: {
    openPopup() {
      this.$refs.slidingPopup.open();
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/button/HamburgerButton.vue